import Compliance_Calender from "../../assets/images/sidebar/compliance_calender.svg";

const complianceCalendarModule = {
  name: "Compliance Calendar",
  key: "compliance_calendar",
  imgSrc: Compliance_Calender,
  submodules: [
    {
      name: "Compliance Calendar",
      key: "compliance_calendar",
      defaultExpanded: false,
      features: [
        {
          key: "compliance_calendar",
          name: "Compliance Calendar",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_compliance_calendar",
              name: "View Compliance Calendar",
              defaultEnabled: true,
              description: "Show company-wide compliance calendar"
            },
            {
              key: "create_event",
              name: "Create Event",
              defaultEnabled: false,
              description: "Add new compliance event"
            },
            {
              key: "edit_event",
              name: "Edit Event",
              defaultEnabled: false,
              description: "Modify existing events"
            },
            {
              key: "delete_event",
              name: "Delete Event",
              defaultEnabled: false,
              description: "Remove events"
            },
            {
              key: "view_service_link_reminder_default_sub_feature",
              name: "View Service Link & Reminder - Default Sub Feature",
              defaultEnabled: false,
              description: "View linked services and reminders"
            },
            {
              key: "create_update_delete_service_link_reminder",
              name: "Create / Update / Delete Service Link & Reminder",
              defaultEnabled: false,
              description: "Link / Unlink service to calendar with reminder"
            },
            {
              key: "create_annual_year",
              name: "Create Annual Year",
              defaultEnabled: false,
              description: "Add Annual Year"
            },
            {
              key: "update_annual_year",
              name: "Update Annual Year",
              defaultEnabled: false,
              description: "Edit Annual Year"
            },
            {
              key: "delete_annual_year",
              name: "Delete Annual Year",
              defaultEnabled: false,
              description: "Remove Annual Year"
            },
          ]
        }
      ]
    }
  ]
};

export default complianceCalendarModule;
